import { IErrorResponse } from "src/api/client/types";
import { API_USER_REACTIONS_URL } from "src/consts/urls";
import { useMutation } from "src/hooks/react-query/use-mutation";
import { EnumReactionEntityType, EnumReactionType } from "src/types/common-enum";

export interface IUpsertReactionParams {
    entityId: string;
    entityType: EnumReactionEntityType;
    reactionType: EnumReactionType;
    reactionValue: number;
    nestedEntity: {
        entityId: string;
        entityType: EnumReactionType;
    } | null;
}

export interface IUpsertReactionResponse {
    creationDate: string;
    entityId: string;
    entityType: string;
    id: string;
    nestedEntity: {
        entityId: string;
        entityType: EnumReactionType;
    } | null;
    reactionType: EnumReactionType;
    reactionValue: number;
    userId: string;
}

export const useUpsertUserReactionMutation = () =>
    useMutation<IUpsertReactionResponse, IErrorResponse, IUpsertReactionParams>(API_USER_REACTIONS_URL, { method: "PUT" });
